import React, { useEffect, useState } from 'react';
import {
  getSubmissionListingMode,
  normalizePipelineStatus,
  submissionIsPublicOnSite,
} from '../../utils/submissions';
import { buildOfferingApiBody } from '../../utils/properties';
import AdminOfferingDetailsFields from './AdminOfferingDetailsFields';

const AdminOfferingDetailsEditor = ({
  record,
  form,
  setForm,
  disabled,
  hint,
  onDraftChange,
  onSave,
  saving
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (getSubmissionListingMode(record) === "rent") return;
    onDraftChange?.(buildOfferingApiBody(form));
  }, [record?.id, form, onDraftChange, record?.listingMode]);

  if (getSubmissionListingMode(record) === "rent") return null;

  const fieldsDisabled = disabled || saving;
  const isLive = submissionIsPublicOnSite(record) || normalizePipelineStatus(record?.status) === 'live';

  return (
    <div className="admin-offering-panel admin-luxury-collapsible">
      <header className="admin-luxury-collapsible__head">
        <button
          type="button"
          className="admin-luxury-collapsible__toggle"
          onClick={() => setExpanded((open) => !open)}
          aria-expanded={expanded}
        >
          <div className="admin-luxury-collapsible__head-main">
            <div className="admin-luxury-collapsible__head-icon admin-luxury-collapsible__head-icon--offering" aria-hidden="true">
              <i className="fas fa-coins"></i>
            </div>
            <div>
              <h3>Offering &amp; timeline</h3>
              <p>Public property page details — funding, manager, risk, and timeline</p>
            </div>
          </div>
          <div className="admin-luxury-collapsible__head-meta">
            {isLive ? (
              <span className="admin-luxury-collapsible__badge admin-luxury-collapsible__badge--live">
                <span className="admin-luxury-collapsible__badge-dot" aria-hidden="true"></span>
                Live on Site
              </span>
            ) : null}
            <i className={`fas fa-chevron-${expanded ? "up" : "down"} admin-luxury-collapsible__chevron`} aria-hidden="true"></i>
          </div>
        </button>
      </header>

      {expanded ? (
        <div className="admin-luxury-collapsible__body">
          {isLive ? (
            <div className="admin-offering-panel__status-banner" role="status">
              <div className="admin-offering-panel__status-icon" aria-hidden="true">
                <i className="fas fa-globe"></i>
              </div>
              <p className="admin-offering-panel__status-text">
                This listing is <strong>Live on Site</strong>. Changes to offering details will update the public listing when saved.
              </p>
            </div>
          ) : null}

          <div className="admin-offering-panel__card">
            <div className="admin-offering-panel__card-body">
              {hint ? <p className="admin-offering-panel__intro">{hint}</p> : null}
              <AdminOfferingDetailsFields
                form={form}
                setForm={setForm}
                disabled={fieldsDisabled}
                idPrefix={`sub-offering-${record?.id || "x"}`}
                variant="admin-luxury"
              />
            </div>

            {onSave ? (
              <div className="admin-offering-panel__card-footer">
                <p className="admin-offering-panel__footer-note">
                  Use <strong>Save offering details</strong> to persist without moving the pipeline. Offering fields are also included when you <strong>Send to …</strong> or <strong>Publish to main page</strong>. Live Listings → <strong>Manage</strong> uses <strong>Save changes</strong>.
                </p>
                <button
                  type="button"
                  className="admin-offering-panel__btn admin-offering-panel__btn--primary"
                  disabled={fieldsDisabled}
                  onClick={() => onSave(buildOfferingApiBody(form))}
                >
                  {saving ? "Saving…" : "Save offering details"}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AdminOfferingDetailsEditor;
